function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1381_999)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.5565 17.5C8.70279 17.7533 8.91318 17.9637 9.16654 18.1099C9.4199 18.2562 9.70729 18.3332 9.99984 18.3332C10.2924 18.3332 10.5798 18.2562 10.8331 18.1099C11.0865 17.9637 11.2969 17.7533 11.4432 17.5M18.3332 6.66663C18.3332 4.74996 17.6665 3.08329 16.6665 1.66663M3.33317 1.66663C2.33317 3.08329 1.6665 4.74996 1.6665 6.66663M2.71817 12.7716C2.60931 12.8909 2.53747 13.0393 2.51138 13.1987C2.4853 13.3581 2.5061 13.5217 2.57126 13.6695C2.63642 13.8173 2.74312 13.9429 2.87838 14.0312C3.01365 14.1195 3.17165 14.1665 3.33317 14.1666H16.6665C16.828 14.1667 16.986 14.1198 17.1214 14.0317C17.2567 13.9436 17.3636 13.8181 17.4289 13.6704C17.4942 13.5227 17.5152 13.3592 17.4894 13.1998C17.4635 13.0404 17.3919 12.8919 17.2832 12.7725C16.1748 11.63 14.9998 10.4158 14.9998 6.66663C14.9998 5.34054 14.4731 4.06877 13.5354 3.13109C12.5977 2.19341 11.3259 1.66663 9.99984 1.66663C8.67375 1.66663 7.40199 2.19341 6.4643 3.13109C5.52662 4.06877 4.99984 5.34054 4.99984 6.66663C4.99984 10.4158 3.824 11.63 2.71817 12.7716Z",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1381_999"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.13737ea8.svg";
export { ForwardRef as ReactComponent };